import React from 'react';

import { Box, Divider, Flex } from '@chakra-ui/react';
import { format, parseISO } from 'date-fns';

import { Paper } from 'uiToolkitV1/Paper';
import { TextBodyMedium, TextLabel } from 'uiToolkitV1/Typography';

const RabbitResultAcknowledgeInfo = ({ acknowledgedOn, acknowledgedBy }) => {
  const date = parseISO(acknowledgedOn);

  const formattedDate = format(date, 'MMM dd, yyyy');

  return (
    <Paper
      bg="#F5F7F9"
      p="16px"
      sx={{
        boxShadow: '0px 0px 2px rgba(0, 0, 0, 0.25)',
      }}
      mb="12px"
    >
      <Flex alignItems="center">
        <Flex p="0 8px" flexDir="column">
          <TextBodyMedium bold>Acknowledgement</TextBodyMedium>
          <TextLabel color="text.g2">
            Acknowledgement confirms the reviewee has received and read their evaluation results
          </TextLabel>
        </Flex>
      </Flex>
      <Divider color="#CFD7DF" opacity={1} my="10px" />
      <Box pl={4}>
        <TextBodyMedium> Review acknowledged by: {acknowledgedBy}</TextBodyMedium>
        <TextBodyMedium> Review acknowledged on: {formattedDate}</TextBodyMedium>
      </Box>
    </Paper>
  );
};

export default RabbitResultAcknowledgeInfo;
